import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e7ca1cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = { class: "main-row" }
const _hoisted_3 = { class: "congrats-card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score-title" }, "Správné odpovědi:", -1))
const _hoisted_5 = { class: "score-value" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-button" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "button solidButton",
    href: "/"
  }, "Zpět na Cestu plastů")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "social-icons" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.youtube.com/@UnipetrolCZ",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "45",
          height: "44",
          viewBox: "0 0 45 44"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "Group_481",
            "data-name": "Group 481",
            transform: "translate(-525 -761)"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              id: "Ellipse_22",
              "data-name": "Ellipse 22",
              d: "M22.5,2a20.809,20.809,0,0,0-7.994,1.577,20.469,20.469,0,0,0-6.518,4.3A19.916,19.916,0,0,0,3.6,14.231a19.621,19.621,0,0,0,0,15.539,19.916,19.916,0,0,0,4.385,6.357,20.469,20.469,0,0,0,6.518,4.3,21.047,21.047,0,0,0,15.987,0,20.469,20.469,0,0,0,6.518-4.3A19.916,19.916,0,0,0,41.4,29.769a19.621,19.621,0,0,0,0-15.539,19.916,19.916,0,0,0-4.385-6.357,20.469,20.469,0,0,0-6.518-4.3A20.809,20.809,0,0,0,22.5,2m0-2A22.254,22.254,0,0,1,45,22,22.254,22.254,0,0,1,22.5,44,22.254,22.254,0,0,1,0,22,22.254,22.254,0,0,1,22.5,0Z",
              transform: "translate(525 761)",
              fill: "#252727"
            }),
            /*#__PURE__*/_createElementVNode("g", {
              id: "Group_42",
              "data-name": "Group 42",
              transform: "translate(536.2 774.592)"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_19",
                "data-name": "Path 19",
                d: "M22.331,2.509A2.866,2.866,0,0,0,20.314.48C18.536,0,11.4,0,11.4,0S4.272,0,2.493.48A2.866,2.866,0,0,0,.477,2.509,30.063,30.063,0,0,0,0,8.034,30.063,30.063,0,0,0,.477,13.56a2.823,2.823,0,0,0,2.016,2c1.779.48,8.911.48,8.911.48s7.132,0,8.911-.48a2.823,2.823,0,0,0,2.016-2,30.063,30.063,0,0,0,.477-5.525,30.064,30.064,0,0,0-.477-5.525M9.071,11.426V4.643l5.961,3.391Z",
                fill: "#252727"
              })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.instagram.com/orlenunipetrol/",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "44",
          height: "44",
          viewBox: "0 0 44 44"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "Group_482",
            "data-name": "Group 482",
            transform: "translate(-603 -761)"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              id: "Ellipse_20",
              "data-name": "Ellipse 20",
              d: "M22,2a20.006,20.006,0,0,0-7.784,38.429A20.006,20.006,0,0,0,29.784,3.571,19.873,19.873,0,0,0,22,2m0-2A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
              transform: "translate(603 761)",
              fill: "#252727"
            }),
            /*#__PURE__*/_createElementVNode("g", {
              id: "Group_40",
              "data-name": "Group 40",
              transform: "translate(613.518 771.499)"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_16",
                "data-name": "Path 16",
                d: "M22.594,6.66a8.278,8.278,0,0,0-.527-2.749A5.8,5.8,0,0,0,18.753.6,8.3,8.3,0,0,0,16,.07C14.791.012,14.406,0,11.33,0S7.869.012,6.661.065A8.283,8.283,0,0,0,3.913.592,5.528,5.528,0,0,0,1.9,1.9,5.578,5.578,0,0,0,.6,3.907,8.3,8.3,0,0,0,.071,6.656C.013,7.868,0,8.253,0,11.329S.013,14.79.066,16a8.279,8.279,0,0,0,.527,2.749A5.586,5.586,0,0,0,1.9,20.757a5.576,5.576,0,0,0,2,1.306,8.3,8.3,0,0,0,2.749.527c1.208.053,1.593.066,4.669.066s3.461-.013,4.669-.066a8.278,8.278,0,0,0,2.748-.527,5.8,5.8,0,0,0,3.315-3.315A8.306,8.306,0,0,0,22.586,16c.053-1.208.066-1.593.066-4.669s0-3.461-.058-4.669m-2.04,9.25a6.21,6.21,0,0,1-.39,2.1,3.758,3.758,0,0,1-2.151,2.151,6.234,6.234,0,0,1-2.1.389c-1.195.053-1.553.066-4.576.066s-3.386-.013-4.576-.066a6.209,6.209,0,0,1-2.1-.389,3.486,3.486,0,0,1-1.3-.845,3.523,3.523,0,0,1-.845-1.3,6.233,6.233,0,0,1-.389-2.1c-.053-1.195-.066-1.554-.066-4.576s.013-3.386.066-4.576a6.207,6.207,0,0,1,.389-2.1,3.444,3.444,0,0,1,.85-1.3,3.516,3.516,0,0,1,1.3-.845,6.234,6.234,0,0,1,2.1-.39c1.2-.053,1.554-.066,4.576-.066s3.386.013,4.576.066a6.208,6.208,0,0,1,2.1.39,3.483,3.483,0,0,1,1.3.845,3.522,3.522,0,0,1,.845,1.3,6.235,6.235,0,0,1,.39,2.1c.053,1.2.066,1.553.066,4.576s-.013,3.377-.066,4.572",
                transform: "translate(0 0.001)",
                fill: "#252727"
              }),
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_17",
                "data-name": "Path 17",
                d: "M130.1,124.28a5.82,5.82,0,1,0,5.82,5.82,5.822,5.822,0,0,0-5.82-5.82m0,9.6a3.775,3.775,0,1,1,3.775-3.775,3.776,3.776,0,0,1-3.775,3.775",
                transform: "translate(-118.771 -118.77)",
                fill: "#252727"
              }),
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_18",
                "data-name": "Path 18",
                d: "M364.082,89.8a1.359,1.359,0,1,1-1.359-1.359,1.359,1.359,0,0,1,1.359,1.359",
                transform: "translate(-345.342 -84.525)",
                fill: "#252727"
              })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.facebook.com/ORLENUnipetrol",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "44",
          height: "44",
          viewBox: "0 0 44 44"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "Group_483",
            "data-name": "Group 483",
            transform: "translate(-680 -761)"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              id: "Ellipse_18",
              "data-name": "Ellipse 18",
              d: "M22,2a20.006,20.006,0,0,0-7.784,38.429A20.006,20.006,0,0,0,29.784,3.571,19.873,19.873,0,0,0,22,2m0-2A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
              transform: "translate(680 761)",
              fill: "#252727"
            }),
            /*#__PURE__*/_createElementVNode("g", {
              id: "Group_38",
              "data-name": "Group 38",
              transform: "translate(696.367 771.838)"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_15",
                "data-name": "Path 15",
                d: "M.351,11.6H2.739v9.83a.351.351,0,0,0,.351.351H7.139a.351.351,0,0,0,.351-.351V11.648h2.745a.351.351,0,0,0,.349-.311L11,7.718a.351.351,0,0,0-.349-.392H7.491V5.058c0-.684.368-1.031,1.095-1.031h2.067A.351.351,0,0,0,11,3.676V.354A.351.351,0,0,0,10.652,0H7.8c-.02,0-.065,0-.13,0A5.46,5.46,0,0,0,4.1,1.346,3.744,3.744,0,0,0,2.858,4.674V7.326H.351A.351.351,0,0,0,0,7.678V11.25a.351.351,0,0,0,.351.351",
                fill: "#252727"
              })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://twitter.com/ORLENUnipetrol",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "44",
          height: "44",
          viewBox: "0 0 44 44"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "Group_484",
            "data-name": "Group 484",
            transform: "translate(-757 -761)"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              id: "Ellipse_19",
              "data-name": "Ellipse 19",
              d: "M22,2a20.006,20.006,0,0,0-7.784,38.429A20.006,20.006,0,0,0,29.784,3.571,19.873,19.873,0,0,0,22,2m0-2A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
              transform: "translate(757 761)",
              fill: "#252727"
            }),
            /*#__PURE__*/_createElementVNode("g", {
              id: "Group_44",
              "data-name": "Group 44",
              transform: "translate(769.051 774.309)"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_20",
                "data-name": "Path 20",
                d: "M20.986,2.019a8.97,8.97,0,0,1-2.479.679A4.278,4.278,0,0,0,20.4.32a8.6,8.6,0,0,1-2.728,1.041A4.3,4.3,0,0,0,10.23,4.3a4.43,4.43,0,0,0,.1.981A12.178,12.178,0,0,1,1.461.784a4.3,4.3,0,0,0,1.322,5.75A4.249,4.249,0,0,1,.839,6v.047a4.322,4.322,0,0,0,3.447,4.227,4.294,4.294,0,0,1-1.128.142,3.8,3.8,0,0,1-.815-.073,4.343,4.343,0,0,0,4.02,3A8.645,8.645,0,0,1,1.03,15.18,8.058,8.058,0,0,1,0,15.121a12.112,12.112,0,0,0,6.6,1.931A12.161,12.161,0,0,0,18.846,4.809c0-.19-.007-.374-.016-.556a8.583,8.583,0,0,0,2.156-2.234",
                transform: "translate(0.14 -0.009)",
                fill: "#252727"
              })
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.linkedin.com/company/orlenunipetrol/",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "44",
          height: "44",
          viewBox: "0 0 44 44"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "Group_485",
            "data-name": "Group 485",
            transform: "translate(-834 -761)"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              id: "Ellipse_21",
              "data-name": "Ellipse 21",
              d: "M22,2a20.006,20.006,0,0,0-7.784,38.429A20.006,20.006,0,0,0,29.784,3.571,19.873,19.873,0,0,0,22,2m0-2A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
              transform: "translate(834 761)",
              fill: "#252727"
            }),
            /*#__PURE__*/_createElementVNode("g", {
              id: "Group_46",
              "data-name": "Group 46",
              transform: "translate(846.479 770.359)"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_21",
                "data-name": "Path 21",
                d: "M194.011,175.257h0v-7.33c0-3.586-.772-6.348-4.964-6.348a4.352,4.352,0,0,0-3.92,2.154h-.058v-1.82H181.1v13.343h4.139V168.65c0-1.74.33-3.422,2.484-3.422,2.123,0,2.154,1.985,2.154,3.533v6.5Z",
                transform: "translate(-173.733 -154.917)",
                fill: "#252727"
              }),
              /*#__PURE__*/_createElementVNode("rect", {
                id: "Rectangle_38",
                "data-name": "Rectangle 38",
                width: "4.144",
                height: "13.343",
                transform: "translate(0.626 6.997)",
                fill: "#252727"
              }),
              /*#__PURE__*/_createElementVNode("path", {
                id: "Path_22",
                "data-name": "Path 22",
                d: "M2.4,0A2.411,2.411,0,1,0,4.8,2.4,2.4,2.4,0,0,0,2.4,0",
                transform: "translate(0.297 0.354)",
                fill: "#252727"
              })
            ])
          ])
        ])
      ])
    ])
  ])
], -1))

import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { resultMessages } from '@/textConfig'

import FinalForm from './FinalForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FinalFormScreen',
  setup(__props) {

const store = useStore()

const isActive = ref(false)
const resultTitle = ref('')
const resultMessage = ref('')

const scoreText = computed(() => `${store.getters.score}/${store.state.questions.length}`)

store.subscribe((mutation) => {
  if (mutation.type === 'finish') {
    isActive.value = true
    const msg = resultMessages.find(
      (m) => m.min <= store.getters.score && store.getters.score <= m.max,
    )
    resultTitle.value = (msg && msg.title) || 'config title error'
    resultMessage.value = (msg && msg.message) || 'config message error'
  }
  if (mutation.type === 'submit') {
    isActive.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(scoreText)), 1),
            _createElementVNode("div", {
              class: "description-title",
              innerHTML: resultTitle.value
            }, null, 8, _hoisted_6),
            _createElementVNode("div", {
              class: "description-text",
              innerHTML: resultMessage.value
            }, null, 8, _hoisted_7)
          ])
        ]),
        _hoisted_8,
        _hoisted_9
      ]))
    : _createCommentVNode("", true)
}
}

})